import React, { useState } from 'react';
import { 
  FaUniversity, 
  FaHome, 
  FaPassport, 
  FaFileInvoiceDollar,
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaRocket,
  FaStar
} from 'react-icons/fa';
import './ServicesSection.css';

const ServicesSection = () => {
  const [activeService, setActiveService] = useState(null);

  const btgServices = [
    {
      icon: <FaUniversity />,
      title: 'Admission',
      subtitle: 'Dans les écoles françaises',
      description: 'Conseils, préparation de dossier, et accompagnement jusqu\'à l\'admission officielle dans l\'école qui correspond le mieux à votre profil.',
      features: [
        'Analyse de votre profil académique',
        'Sélection des établissements adaptés',
        'Préparation complète du dossier',
        'Suivi jusqu\'à l\'acceptation'
      ],
      color: '#073b8f'
    },
    {
      icon: <FaHome />,
      title: 'Logement',
      subtitle: 'Étudiant en france',
      description: 'Accès à un réseau de résidences et de logements étudiants à prix abordables, avec accompagnement administratif complet.',
      features: [
        'Réseau de résidences partenaires',
        'Accompagnement administratif',
        'Prix étudiants accessibles',
        'Localisation stratégique'
      ],
      color: '#c0264a'
    },
    {
      icon: <FaPassport />,
      title: 'Visa',
      subtitle: 'étudiant',
      description: 'Préparation complète du dossier, assistance à la prise de rendez-vous et accompagnement jusqu\'à la validation du visa.',
      features: [
        'Préparation du dossier visa',
        'Assistance aux rendez-vous',
        'Simulation d\'entretien',
        'Suivi jusqu\'à l\'obtention'
      ],
      color: '#073b8f'
    },
    {
      icon: <FaFileInvoiceDollar />,
      title: 'AVI',
      subtitle: 'Attestation de virement irrévocable',
      description: 'Nous facilitons votre demande d\'AVI auprès d\'établissements reconnus pour garantir votre preuve de ressources.',
      features: [
        'Demande auprès d\'établissements reconnus',
        'Garantie de preuve de ressources',
        'Processus simplifié',
        'Accompagnement administratif'
      ],
      color: '#c0264a'
    }
  ];

  const toggleService = (index) => {
    setActiveService(activeService === index ? null : index);
  };

  return (
    <section className="btg-services-section-light" id="btg-services">
      <div className="btg-container-light">
        {/* En-tête de section - Style clair premium */}
        <div className="btg-services-header-light">
          <div className="btg-header-content-light">
            <div className="btg-header-badge">
              <FaRocket className="btg-badge-icon" />
              <span>Services Premium</span>
            </div>
            <h1 className="btg-main-title-light">Notre accompagnement</h1>
            <p className="btg-main-subtitle-light">Sur mesure et garanti</p>
            <p className="btg-section-subtitle-light">
              Un parcours complet et personnalisé pour concrétiser votre projet d'études en France
            </p>
            <div className="btg-header-decoration-light">
              <div className="btg-decoration-line-light"></div>
              <div className="btg-decoration-dot-light"></div>
              <div className="btg-decoration-glow-light"></div>
              <div className="btg-decoration-dot-light"></div>
              <div className="btg-decoration-line-light"></div>
            </div>
          </div>
        </div>

        {/* Section des services avec design clair */}
        <div className="btg-services-horizontal-light">
          <div className="btg-services-wrapper-light">
            <div className="btg-services-cards-grid-light">
              {btgServices.map((service, index) => (
                <div 
                  key={index} 
                  className={`btg-service-card-light ${activeService === index ? 'btg-active-light' : ''}`}
                  style={{ '--btg-accent-color': service.color }}
                  onClick={() => toggleService(index)}
                >
                  {/* Effet de lueur */}
                  <div className="btg-card-glow" style={{ '--glow-color': service.color }}></div>
                  
                  <div className="btg-service-card-header-light">
                    <div className="btg-service-icon-container-light">
                      <div className="btg-service-main-icon-light">
                        {service.icon}
                      </div>
                      <div className="btg-icon-glow"></div>
                    </div>
                    <h3 className="btg-service-card-title-light">{service.title}</h3>
                    <div className="btg-service-arrow-light">
                      {activeService === index ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  </div>

                  {/* Contenu dépliable */}
                  <div className="btg-service-expandable-light">
                    <div className="btg-service-content-light">
                      <p className="btg-service-card-subtitle-light">{service.subtitle}</p>
                      <p className="btg-service-card-description-light">{service.description}</p>
                      
                      <div className="btg-service-features-light">
                        <h4 className="btg-features-title-light">
                          <FaStar className="btg-features-icon" />
                          Ce qui est inclus :
                        </h4>
                        <ul className="btg-features-list-light">
                          {service.features.map((feature, featureIndex) => (
                            <li key={featureIndex} className="btg-feature-item-light">
                              <FaCheckCircle className="btg-feature-check-light" />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Section CTA claire */}
        <div className="btg-services-cta-light">
          <div className="btg-cta-content-light">
            <div className="btg-cta-header-light">
              <h3 className="btg-cta-title-light">Prêt à transformer votre rêve en réalité ?</h3>
              <p className="btg-cta-subtitle-light">Votre avenir en France commence ici</p>
            </div>
            <p className="btg-cta-text-light">
              Rejoignez les centaines d'étudiants qui nous font confiance pour leur projet d'études en France
            </p>
            <button className="btg-cta-button-light">
              <FaRocket className="btg-cta-icon" />
              Démarrer mon projet gratuitement
              <div className="btg-button-glow"></div>
            </button>
            
            <div className="btg-cta-stats-light">
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">500+</div>
                <div className="btg-stat-label-light">Étudiants accompagnés</div>
              </div>
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">95%</div>
                <div className="btg-stat-label-light">Taux de réussite</div>
              </div>
              <div className="btg-stat-light">
                <div className="btg-stat-number-light">98%</div>
                <div className="btg-stat-label-light">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Background animé pour le CTA */}
          <div className="btg-cta-background-light">
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
        <div className="btg-bg-element btg-bg-4"></div>
      </div>
    </section>
  );
};

export default ServicesSection;